// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3XWRcyTU","content":"mbp391w5"};